import { type HighlightsController } from '@databases/highlights';
import { createHighlightsEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface HighlightsEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createHighlightsEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.HIGHLIGHTS_EFFECT,
    type: 'effect',
    // Always active — highlights are the core visual representation
    // of selections and are fundamental to the selections machine.

    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createHighlightsEffect(highlightsController);
    },
  };
}
